// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vod-Board {
  display: grid;
  grid-template-columns: 73vw auto;
  gap: 1.5vw;
  margin-top: 1.5vh;
}
.vod-Scene {
  display: grid;
  position: relative;
  place-items: center;
  box-shadow:
    0 4px 8px 0 #0003,
    0 6px 20px 0 #00000030;
  border: 2px solid #1a6a7c;
}
.vod-BackgroundImg {
  width: 100%;
  min-height: max-content;
}

.vod-console.run {
  font-family: Consolas;
  height: auto;
  width: auto;
  background: white;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 5px;
}

.vod-program-line {
  padding: 2px 5px;
  margin: 1px 0;
  border-left: 3px solid transparent;
}

.vod-program-line.current-line {
  background-color: rgb(181, 234, 255);
}

.vod-program-line.error-line {
  background-color: rgb(255, 159, 159);
}

.vod-console {
  font-family: Consolas;
  max-height: 42vw;
  width: auto;
  border: solid 1px;
  font-size: 1.5vw;
  padding: 10px;
  overflow-y: scroll;
  box-shadow:
    0 4px 8px 0 #0003,
    0 6px 20px 0 #00000030;
  border-color: rgb(0, 58, 94);
  resize: none;
  color: rgb(0, 58, 94);
}

.vod-Management-bar {
  display: grid;
}
.vod-board-loading {
  width: 100%;
  height: 37.5vw;
  font-size: 2vw;
  display: grid;
  justify-content: center;
  align-items: center;
  background: white;
}
/* div сосуды общие  */
.vod-vessel {
  position: absolute;
  width: 20vw;
  height: 20vw;
  bottom: 7.2vw;
}
/* img сосудов А и B*/
.vod-img-VesselA {
  position: relative;
  inset: 0;
  height: 100%;
  width: 100%;
}
.vod-img-VesselA-water{
  position: absolute;
  inset: 0;
   height: 100%;
  width: 100%;
   /* 30 max  90 min = 60*/
}
.vod-img-VesselB-water{
  position: absolute;
  inset: 0;
   height: 100%;
  width: 100%;

   /* 42 начальная 92 конечная | 92-42 = 50*/
}

.vod-img-VesselB {
  position: relative;
  inset: 0;
  height: 100%;
  width: 100%;
}
/* div вместе с frog и textvolume */
.vod-Frog_and_TextVolume {
  height: 6vw;
  position: absolute;
  right: 34%;
  z-index: 1;
  bottom: 97.6%;
}
/* анимация лягушки с цифрой */
.vod-WinFrogTextVolume {
  animation: JumpToLily 1.5s ease-out forwards;
}
/* img лягушка */
.vod-frog {
  height: inherit;
}
/* общий span с объёмом сосуда */
.vod-textVolume {
  position: absolute;
  font-family: "Monte Carlo";
  font-size: 2vw;
  z-index: 2;
  left: 62%;
  top: 66%;
  transform: translate(-50%, -50%);
}
/* общий span с количество воды в сосуде */
.vod-textVessel {
  position: absolute;
  font-family: "Monte Carlo";
  font-size: 1.5vw;
  z-index: 2;
  transform: translate(-50%, -50%);
}
/* крышка общие А B */
.vod-cork_A {
  position: absolute;
  height: 2.8vw;
  z-index: 2;
  right: 8.2vw;
  bottom: 99.9%;
  animation: appear 2.7s ease-in forwards;
}
.vod-cork_B {
  position: absolute;
  height: 2.8vw;
  z-index: 2;
  right: 7.9vw;
  bottom: 99.9%;
  animation: appear 2.7s ease-in forwards;
}

/* ball */
.vod-ballVesselA {
  right: 22.5vw;
}

.vod-ballVesselB {
  right: 4.5vw;
}
.vod-Frog_TextVolume_ballB {
  right: 32%;
}

.vod-textVesselball_A {
  left: 66.3%;
  top: 60%;
}

.vod-textVesselball_B {
  left: 67%;
  top: 64%;
}

/* Beaker */
.vod-beakerVesselA {
  right: 23vw;
}
.vod-beakerVesselB {
  height: 18vw;
  right: 4.5vw;
}
.vod-Frog_TextVolume_beakerA {
  right: 31%;
  z-index: 3;
}
.vod-cork_beakerA {
  right: 36.3%;
}

.vod-textVesselbeaker_A {
  left: 72.3%;
  top: 73%;
}

.vod-textVesselbeaker_B {
  left: 65.4%;
  top: 68%;
}

@keyframes JumpToLily {
  0% {
    right: 33%;
    bottom: 97%;
  }

  10% {
    right: 40%;
    bottom: 110%;
  }
  18% {
    right: 45%;
    bottom: 118%;
  }
  25% {
    right: 47%;
    bottom: 120%;
  }

  35% {
    right: 50%;
    bottom: 113%;
  }
  45% {
    right: 54%;
    bottom: 95%;
  }

  55% {
    right: 56%;
    bottom: 75%;
  }
  65% {
    right: 53%;
    bottom: 55%;
  }

  75% {
    right: 50%;
    bottom: 20%;
  }
  85% {
    right: 46%;
    bottom: 8%;
  }

  92% {
    right: 44%;
    bottom: 0%;
  }

  100% {
    right: 38%;
    bottom: -5%;
  }
}
@keyframes appear {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  50% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Vodyanoy/styles/Board.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB;;0BAEwB;EACxB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB;;0BAEwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;GACP,YAAY;EACb,WAAW;GACV,uBAAuB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;GACP,YAAY;EACb,WAAW;;GAEV,yCAAyC;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;AACA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;AACf;AACA,8BAA8B;AAC9B;EACE,4CAA4C;AAC9C;AACA,gBAAgB;AAChB;EACE,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".vod-Board {\n  display: grid;\n  grid-template-columns: 73vw auto;\n  gap: 1.5vw;\n  margin-top: 1.5vh;\n}\n.vod-Scene {\n  display: grid;\n  position: relative;\n  place-items: center;\n  box-shadow:\n    0 4px 8px 0 #0003,\n    0 6px 20px 0 #00000030;\n  border: 2px solid #1a6a7c;\n}\n.vod-BackgroundImg {\n  width: 100%;\n  min-height: max-content;\n}\n\n.vod-console.run {\n  font-family: Consolas;\n  height: auto;\n  width: auto;\n  background: white;\n  overflow: auto;\n  border: 1px solid #ccc;\n  padding: 5px;\n}\n\n.vod-program-line {\n  padding: 2px 5px;\n  margin: 1px 0;\n  border-left: 3px solid transparent;\n}\n\n.vod-program-line.current-line {\n  background-color: rgb(181, 234, 255);\n}\n\n.vod-program-line.error-line {\n  background-color: rgb(255, 159, 159);\n}\n\n.vod-console {\n  font-family: Consolas;\n  max-height: 42vw;\n  width: auto;\n  border: solid 1px;\n  font-size: 1.5vw;\n  padding: 10px;\n  overflow-y: scroll;\n  box-shadow:\n    0 4px 8px 0 #0003,\n    0 6px 20px 0 #00000030;\n  border-color: rgb(0, 58, 94);\n  resize: none;\n  color: rgb(0, 58, 94);\n}\n\n.vod-Management-bar {\n  display: grid;\n}\n.vod-board-loading {\n  width: 100%;\n  height: 37.5vw;\n  font-size: 2vw;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  background: white;\n}\n/* div сосуды общие  */\n.vod-vessel {\n  position: absolute;\n  width: 20vw;\n  height: 20vw;\n  bottom: 7.2vw;\n}\n/* img сосудов А и B*/\n.vod-img-VesselA {\n  position: relative;\n  inset: 0;\n  height: 100%;\n  width: 100%;\n}\n.vod-img-VesselA-water{\n  position: absolute;\n  inset: 0;\n   height: 100%;\n  width: 100%;\n   /* 30 max  90 min = 60*/\n}\n.vod-img-VesselB-water{\n  position: absolute;\n  inset: 0;\n   height: 100%;\n  width: 100%;\n\n   /* 42 начальная 92 конечная | 92-42 = 50*/\n}\n\n.vod-img-VesselB {\n  position: relative;\n  inset: 0;\n  height: 100%;\n  width: 100%;\n}\n/* div вместе с frog и textvolume */\n.vod-Frog_and_TextVolume {\n  height: 6vw;\n  position: absolute;\n  right: 34%;\n  z-index: 1;\n  bottom: 97.6%;\n}\n/* анимация лягушки с цифрой */\n.vod-WinFrogTextVolume {\n  animation: JumpToLily 1.5s ease-out forwards;\n}\n/* img лягушка */\n.vod-frog {\n  height: inherit;\n}\n/* общий span с объёмом сосуда */\n.vod-textVolume {\n  position: absolute;\n  font-family: \"Monte Carlo\";\n  font-size: 2vw;\n  z-index: 2;\n  left: 62%;\n  top: 66%;\n  transform: translate(-50%, -50%);\n}\n/* общий span с количество воды в сосуде */\n.vod-textVessel {\n  position: absolute;\n  font-family: \"Monte Carlo\";\n  font-size: 1.5vw;\n  z-index: 2;\n  transform: translate(-50%, -50%);\n}\n/* крышка общие А B */\n.vod-cork_A {\n  position: absolute;\n  height: 2.8vw;\n  z-index: 2;\n  right: 8.2vw;\n  bottom: 99.9%;\n  animation: appear 2.7s ease-in forwards;\n}\n.vod-cork_B {\n  position: absolute;\n  height: 2.8vw;\n  z-index: 2;\n  right: 7.9vw;\n  bottom: 99.9%;\n  animation: appear 2.7s ease-in forwards;\n}\n\n/* ball */\n.vod-ballVesselA {\n  right: 22.5vw;\n}\n\n.vod-ballVesselB {\n  right: 4.5vw;\n}\n.vod-Frog_TextVolume_ballB {\n  right: 32%;\n}\n\n.vod-textVesselball_A {\n  left: 66.3%;\n  top: 60%;\n}\n\n.vod-textVesselball_B {\n  left: 67%;\n  top: 64%;\n}\n\n/* Beaker */\n.vod-beakerVesselA {\n  right: 23vw;\n}\n.vod-beakerVesselB {\n  height: 18vw;\n  right: 4.5vw;\n}\n.vod-Frog_TextVolume_beakerA {\n  right: 31%;\n  z-index: 3;\n}\n.vod-cork_beakerA {\n  right: 36.3%;\n}\n\n.vod-textVesselbeaker_A {\n  left: 72.3%;\n  top: 73%;\n}\n\n.vod-textVesselbeaker_B {\n  left: 65.4%;\n  top: 68%;\n}\n\n@keyframes JumpToLily {\n  0% {\n    right: 33%;\n    bottom: 97%;\n  }\n\n  10% {\n    right: 40%;\n    bottom: 110%;\n  }\n  18% {\n    right: 45%;\n    bottom: 118%;\n  }\n  25% {\n    right: 47%;\n    bottom: 120%;\n  }\n\n  35% {\n    right: 50%;\n    bottom: 113%;\n  }\n  45% {\n    right: 54%;\n    bottom: 95%;\n  }\n\n  55% {\n    right: 56%;\n    bottom: 75%;\n  }\n  65% {\n    right: 53%;\n    bottom: 55%;\n  }\n\n  75% {\n    right: 50%;\n    bottom: 20%;\n  }\n  85% {\n    right: 46%;\n    bottom: 8%;\n  }\n\n  92% {\n    right: 44%;\n    bottom: 0%;\n  }\n\n  100% {\n    right: 38%;\n    bottom: -5%;\n  }\n}\n@keyframes appear {\n  0% {\n    opacity: 0;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
